import React from 'react'
import { formatCurrency } from 'Utils'

const HifiveContent = ({ rewardAmount, requiredSignUpCountHiFIve }) => {
  return (
    <div>
      <p className="fs-20 pt-8 pb-4 fw-600">Invite and earn {formatCurrency(rewardAmount)} every month</p>
      <p className="fs-3 fw-400">Invite {requiredSignUpCountHiFIve} friends to sign up and earn {formatCurrency(rewardAmount)} on Cleartrip. Earn every month when {requiredSignUpCountHiFIve} new friends sign up.</p>
      <br />
    </div>
  )
}

export default HifiveContent
